import { ElementSource } from "chq";

type LanguageGroups = { [key: string]: ElementSource[] };

const updateSubtitleIndexes = (
  subtitleElements: ElementSource[]
): ElementSource[] => {
  // Group elements by language and sort them by time
  const elementsByLanguage: LanguageGroups = subtitleElements.reduce(
    (acc: LanguageGroups, element: ElementSource) => {
      const [_prefix, _index, language] = element.name.split("-", 3);
      if (!acc[language]) {
        acc[language] = [];
      }
      acc[language].push(element);
      return acc;
    }, {}
  );

  // Sort each language group by time and reindex
  return Object.entries(elementsByLanguage).flatMap(
    ([_language, elements]) => (
      elements
        .sort((a: ElementSource, b: ElementSource) => a.time - b.time)
        .map((element: ElementSource, index: number) => {
          const [prefix, _index, ...rest] = element.name.split("-");
          return {
            ...element,
            name: `${prefix}-${index}-${rest.join("-")}`
          };
        })
    )
  );
};

export default updateSubtitleIndexes;
